import { render, staticRenderFns } from "./PriceBotUpsell.vue?vue&type=template&id=1583bd20&"
import script from "./PriceBotUpsell.vue?vue&type=script&lang=js&"
export * from "./PriceBotUpsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports